

const testimonialInfo = [
    {  
        id: '01',
        comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae explicabo consectetur ut aut. Quasi odio quia suscipit esse ducimus id et, exercitationem perferendis sequi dolore. ',
        name: ' Wilson Harry',
        address: 'New York',
        image: "https://i.ibb.co/1Jz5618/Wilson-Harry.png"
    },
    {
        id: '02',
        comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae explicabo consectetur ut aut. Quasi odio quia suscipit esse ducimus id et, exercitationem perferendis sequi dolore. ',
        name: ' Wilson Harry',
        address: 'california',
        image: "https://i.ibb.co/1Jz5618/Wilson-Harry.png"
    },
    {
        id: '03',
        comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae explicabo consectetur ut aut. Quasi odio quia suscipit esse ducimus id et, exercitationem perferendis sequi dolore.',
        name: ' Wilson Harry',
        address: 'Texas',
        image: "https://i.ibb.co/1Jz5618/Wilson-Harry.png"
    },
    {
        id: '04',
        comments: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quae explicabo consectetur ut aut. Quasi odio quia suscipit esse ducimus id et, exercitationem perferendis sequi dolore.',
        name: ' Wilson Harry',
        address: 'New Jersey',
        image: "https://i.ibb.co/1Jz5618/Wilson-Harry.png"
    }
]

export default testimonialInfo;